module.exports = __webpack_public_path__ + "img/graph-02.c628a34e.png";